import {
  DPLayer,
  DPLayerMapping,
  DPMeta,
} from 'common/src/modules/dynamicParameters/dynamicParameters.types';
import {
  DPMappingResizeOption,
  DPMappingVerticalAlign,
  SourceLayerType,
} from 'common/src/modules/dynamicParameters/dynamicParameters.enums';
import _values from 'lodash/values';
import _groupBy from 'lodash/groupBy';
import {getDataFromMeta} from 'common/src/modules/dynamicParameters/dynamicParameters.dataConverters';

function fillNoMappingWithEmpty(meta: DPMeta, mapping: DPLayerMapping[]) {
  return _values(_groupBy(meta.comps, 'id'))
    .map(([{id: compId, layers}]) =>
      layers.map((layerMeta) => {
        const existingMapping = mapping.find(
          ({id, compId: mappingComp}) =>
            +id.split('-').pop() === layerMeta.mappingId && +compId === +mappingComp,
        );

        if (!existingMapping) return createEmptyLayerMapping({compId, layerMeta});

        if (layerMeta.type === SourceLayerType.Text && !existingMapping.txtData) {
          existingMapping.txtData = null;
        }

        return existingMapping || createEmptyLayerMapping({compId, layerMeta});
      }),
    )
    .flat();
}

function createEmptyLayerMapping({
  compId,
  layerMeta,
}: {
  compId: string;
  layerMeta: DPLayer;
}): DPLayerMapping {
  return {
    compId,
    id: `${compId}-${layerMeta.layerIndex}-${layerMeta.mappingId}`,
    ...getDataFromMeta({...layerMeta, id: `${layerMeta.layerIndex}`}),
    alt: null,
    clickUrl: null,
    colorOverlay: null,
    conditions: [],
    fillColor: null,
    gradDynColors: null,
    html: null,
    isValid: true,
    resizeOption: layerMeta.imageMetadata?.resizeOption || DPMappingResizeOption.NoResize,
    strokeColor: null,
    txtData: null,
    url: null,
    widget: null,
    font: null,
    qr: null,
    subtitle: null,
  };
}

function createEmptyLayerTxtData(): DPLayerMapping['txtData'] {
  return {
    elipsys: true,
    minFontSize: 0,
    strikeWidth: 0,
    textVerticalAlign: DPMappingVerticalAlign.Top,
    wrapping: true,
    parts: [
      {
        blShift: null,
        isStatic: false,
        newLine: false,
        size: null,
        val: null,
      },
    ],
  };
}

export {createEmptyLayerTxtData};
export default fillNoMappingWithEmpty;
